"use strict";

var TeamSelectFilterActions = require("app/shared/actions/team-select-filter-actions");
var TeamSelectFilterStore = require("app/shared/stores/team-select-filter-store");
var Dropdown = require("app/shared/components/Dropdown/dropdown");
var _ = require("underscore");

var TeamSelectFilter = React.createClass({
  mixins: [Reflux.ListenerMixin],
  getInitialState: function() {
    var initialState = TeamSelectFilterStore.state;
    return initialState;
  },
  componentDidMount: function(){
    this.listenTo(TeamSelectFilterStore, this.setState);
    TeamSelectFilterActions.loadTeams();
  },
  handleChange: function(obj) {
    if (obj.value != "") {
      var selectedTeam = _.find(this.state.teams, function(team) {
        return team.id == obj.value;
      });

      var userIdsInTeam = _.map(selectedTeam.user_teams, function(member) {
        return member.user.id;
      });
    }

    this.props.setFilter("teamId", obj.value, userIdsInTeam || []);

    this.setState({
      selectedId: obj.value
    });
  },
  buildTeamOptions: function() {
    var teamOptions = _.map(this.state.teams, function(team){
      return { id: team.id, name: team.name };
    })

    return _.sortBy(teamOptions, "name");
  },
  getOptions: function() {
    var options = [{ id: "", name: "Equipes" }];

    options = options.concat(
      this.buildTeamOptions()
    );

    return options;
  },
  render: function() {
    return(
      <div className={`userSelect-filter fs-14 ${this.props.className}`}>
        <div className="d-ib">
          <Dropdown ref="team"
            handleCustomChange={this.handleChange}
            value={this.state.selectedId}
            options={this.getOptions()} className="w-120 b-light"/>
        </div>
      </div>
    );
  }
});

module.exports = TeamSelectFilter;



// WEBPACK FOOTER //
// ./app/shared/components/TeamSelectFilter/team-select-filter.jsx